import { render } from "./SavedDealsPage.vue?vue&type=template&id=711adcfd"
import script from "./SavedDealsPage.vue?vue&type=script&lang=js"
export * from "./SavedDealsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__